function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { ConfirmationModal, TextField, Typography, useOverlayContext } from 'seagull';
import ExternalLinkButton from "../../../../components/ExternalLinkButton";
import { useStoreActions } from "../../../../contexts";
import { handleRequest } from "../../../../infra/utils";
import { getPMDetails } from "../../../PracticeManagement/pm.utils";
import { PracticeManagement } from "../../../../types/api.model";
import { connectControllerToTextField } from "../../../../utils/react-hook-form.utils";
import styles from "./ConnectKeeperModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConnectKeeperModal(_ref) {
  let {
    dismissModal
  } = _ref;
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      clientId: '',
      clientSecret: ''
    }
  });
  const {
    api
  } = useStoreActions();
  const {
    showErrorToast,
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    fetchIntegrations
  } = useStoreActions();
  const keeperDetails = getPMDetails(PracticeManagement.Keeper);
  const submit = async data => {
    startLoader();
    const {
      success
    } = await handleRequest(api.keeper.connect(data));
    if (!success) {
      showErrorToast('Invalid credentials', 'keeper-connect-error-toast');
    } else {
      await fetchIntegrations();
      dismissModal();
    }
    stopLoader();
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Connect ".concat(keeperDetails.name),
    width: "650px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.keeperModalContainer,
      "data-testid": "keeper-connect-modal-content",
      children: [/*#__PURE__*/_jsxs(Typography, {
        align: "left",
        children: ["To integrate with ", keeperDetails.name, ", request your Client ID and Client Secret from the", ' ', keeperDetails.name, " support team and paste it into the field below.", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
          openInNewTab: true,
          href: keeperDetails.articleLink,
          underline: "none",
          children: "Learn more"
        })]
      }), /*#__PURE__*/_jsx(Controller, {
        name: "clientId",
        control: control,
        rules: requiredValidation('Please provide a Client ID'),
        render: p => /*#__PURE__*/_jsx(TextField, _objectSpread({
          collapseHelperText: false,
          testid: "keeper-client-id",
          label: "Client ID"
        }, connectControllerToTextField(p)))
      }), /*#__PURE__*/_jsx(Controller, {
        name: "clientSecret",
        control: control,
        rules: requiredValidation('Please provide a Client Secret'),
        render: p => /*#__PURE__*/_jsx(TextField, _objectSpread({
          collapseHelperText: false,
          testid: "keeper-client-secret",
          label: "Client Secret"
        }, connectControllerToTextField(p)))
      })]
    }),
    primaryButtonLabel: "Set",
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: handleSubmit(submit),
    onCloseButtonClick: dismissModal,
    onSecondaryButtonClick: dismissModal,
    "data-testid": "connect-keeper-modal"
  });
}